type LatLng = google.maps.LatLngLiteral;
type GeocoderResult = google.maps.GeocoderResult;
type GeocoderStatus = google.maps.GeocoderStatus;

type ParseGeocoderResultsFunction = (
  results: GeocoderResult[],
  status: GeocoderStatus
) => GeocoderResult | null | undefined;

export const getStreetAddressFromResults: ParseGeocoderResultsFunction = (results, status) => {
  if (status !== window.google.maps.GeocoderStatus.OK) {
    return null;
  }

  // Grab the address component that includes the street address
  const streetAddress = results.find(result => result.types.includes('street_address'));
  // otherwise, Route address will be used as backup if a street address is not found
  const routeAddress = results.find(result => result.types.includes('route'));

  return streetAddress ?? routeAddress;
};

export const getCoordinateDetails = (
  { lat, lng }: LatLng,
  callback: ParseGeocoderResultsFunction = getStreetAddressFromResults
): Promise<google.maps.GeocoderResult | null | undefined> => {
  if (!window.google) {
    return Promise.resolve(null);
  }

  const geocoder = new window.google.maps.Geocoder();

  return new Promise(resolve => {
    if (!lat || !lng) {
      resolve(null);
    }

    if (!geocoder) {
      resolve(null);
    }

    geocoder.geocode(
      {
        location: new window.google.maps.LatLng(lat, lng),
      },
      (results, status) => {
        const parsedResult = callback(results, status);

        resolve(parsedResult);
      }
    );
  });
};
